<template>
  <div>
    <b-row class="mx-2 py-3 align-items-center">
      <b-col cols="4" lg="6">
        <h3>เส้นทางการเดินรถ</h3>
      </b-col>
      <b-col cols="8" lg="6">
        <div class="d-flex flex-row justify-content-end">
          <b-button
            variant="outline-success"
            @click="addCategory()"
            v-if="category && !isEdit">
            <b-icon icon="plus" class="mb-1"></b-icon> หมวดหมู่เส้นทาง
          </b-button>
          <b-button
            variant="outline-success"
            @click="add()"
            :disabled="
              (!category && [null, 'custom'].includes(form.category.id)) ||
              (!category && ![1].includes(form.rate_type)) ||
              (category &&
                form.categoryRoutes &&
                form.categoryRoutes.length < 1)
            "
            v-if="!isEdit">
            <b-icon icon="plus" class="mb-1"></b-icon> เพิ่มเส้นทาง
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr class="border-dashed-spacing my-2" />
    <template
      v-if="category && form.categoryRoutes && form.categoryRoutes.length > 0">
      <b-tabs card v-model="tabIndex" active-nav-item-class="tabs-active">
        <b-tab
          v-for="(categoryItem, index) in form.categoryRoutes"
          :key="index">
          <template v-slot:title>
            <div class="d-flex flex-row align-items-center mx-2">
              <span class="pr-2">{{ categoryItem.name }}</span>
              <b-button
                variant="outline-danger"
                size="sm"
                pill
                @click="confirmRemoveCategory(index)">
                <b-icon icon="trash-fill"></b-icon>
              </b-button>
            </div>
          </template>
          <b-row
            :class="[
              'mx-2',
              i === 0 ? 'pt-3' : i === categoryItem.routes.length - 1 && 'pb-3',
            ]"
            v-for="(route, i) in categoryItem.routes"
            :key="i">
            <b-col cols="6" class="bd-right">
              <b-form-group
                :label="
                  i === 0
                    ? 'ต้นทาง'
                    : i === categoryItem.routes.length - 1 &&
                      categoryItem.routes.length > 1
                    ? 'ปลายทาง'
                    : 'ระหว่างทาง'
                ">
                <b-form-input v-model="categoryItem.routes[i].name" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-row class="d-flex align-items-center">
                <b-col :cols="isEdit ? '12' : '10'">
                  <b-form-group label="map url">
                    <b-input-group>
                      <b-form-input v-model="categoryItem.routes[i].url" />
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="2" v-if="!isEdit">
                  <b-button
                    :disabled="categoryItem.routes.length < 2"
                    variant="outline-danger"
                    class="mt-2"
                    @click="confirmRemoveRoute(i)">
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </template>
    <template v-else-if="!category && form.routes.length > 0">
      <b-row
        :class="[
          'mx-2',
          i === 0 ? 'pt-3' : i === form.routes.length - 1 && 'pb-3',
        ]"
        v-for="(route, i) in form.routes"
        :key="i">
        <b-col cols="6" class="bd-right">
          <b-form-group
            :label="
              i === 0
                ? 'ต้นทาง'
                : i === form.routes.length - 1 && form.routes.length > 1
                ? 'ปลายทาง'
                : 'ระหว่างทาง'
            ">
            <b-form-input v-model="form.routes[i].name" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-row class="d-flex align-items-center">
            <b-col :cols="isEdit ? '12' : '10'">
              <b-form-group label="map url">
                <b-input-group>
                  <b-form-input v-model="form.routes[i].url" />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="2" v-if="!isEdit">
              <b-button
                :disabled="
                  (form.rate_type === 2 && form.routes.length < 3) ||
                  (form.rate_type === 1 && form.routes.length < 4)
                "
                variant="outline-danger"
                class="mt-2"
                @click="confirmRemoveRoute(i)">
                <b-icon icon="trash-fill"></b-icon>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-row>
        <b-col lg="12" class="my-4 text-center">
          <h4 class="text-muted">ยังไม่มีเส้นทางในขณะนี้</h4>
        </b-col>
      </b-row>
    </template>
    <ModalCategoryRoute :form="form" :formCategory="formCategory" />
  </div>
</template>
<script>
import ModalCategoryRoute from "@/components/Category/ModalCategoryRoute.vue";

export default {
  components: {
    ModalCategoryRoute,
  },
  props: {
    form: {
      type: Object,
    },
    category: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formCategory: {
        isShow: false,
        isLoading: false,
      },
      tabIndex: 0,
    };
  },
  created() {},
  methods: {
    add() {
      if (this.category) {
        this.form.categoryRoutes[this.tabIndex].routes.push({
          name: "",
          url: "",
        });
      } else {
        this.form.routes.push({ name: "", url: "" });
      }
    },
    addCategory() {
      this.formCategory.isShow = true;
    },
    confirmRemoveCategory(index) {
      this.$bvModal
        .msgBoxConfirm("คุณต้องการลบหมวดหมู่นี้หรือไม่?", {
          title: "ยืนยันการลบ",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.removeCategory(index);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeCategory(i) {
      this.form.categoryRoutes.splice(i, 1);
    },
    confirmRemoveRoute(index) {
      this.$bvModal
        .msgBoxConfirm("คุณต้องการลบเส้นทางนี้หรือไม่?", {
          title: "ยืนยันการลบ",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.remove(index);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    remove(i) {
      if (this.category) {
        this.form.categoryRoutes[this.tabIndex].routes.splice(i, 1);
      } else {
        this.form.routes.splice(i, 1);
      }
    },
  },
  computed: {
    isDetails() {
      return !!this.$route.params.id;
    },
  },
  mounted() {},
};
</script>
